// src/pages/WebsiteHome.js
import React from "react";

const WebsiteHome = () => (
  <div style={{ padding: 20 }}>
    <h2>Welcome to the Website Home 🏠</h2>
    <p>This is public content for general users.</p>
  </div>
);

export default WebsiteHome;
